import CurrentUser from "lib/current_user"
import Env from "lib/env"

function LinksRewriteProcessing() {
  const userData = document.querySelector('meta[name="current-user-data"]')?.content

  if (!userData)
    return


  CurrentUser.initialize(JSON.parse(userData))

  const envData = document.querySelector('meta[name="env-data"]')?.content
  Env.initialize(JSON.parse(envData))

  if (CurrentUser.hasGarStatus()) {
    processLinks(CurrentUser, Env)

    // Also handle dynamically added links with a MutationObserver
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          processLinks(CurrentUser, Env)
        }
      })
    })

    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true })

    function processLinks(CurrentUser, Env) {
      const links = document.querySelectorAll('a[href]')
      const URL_PATTERNS = {
        startsWith: [ '/', '#' ],
        includes: [ 'leptitobservatoire.fr', 'scalingo.io', '&IDO=' ]
      }

      links.forEach(function(link) {
        const href = link.getAttribute('href')

        // Skip modification if:
        // 1. Link starts with '/' or '#' (internal relative URL)
        // 2. Link contains 'leptitobservatoire.fr' (your domain)
        // 3. Link has already been processed (to avoid double processing)
        if (URL_PATTERNS.startsWith.some(pattern => href.startsWith(pattern)) ||
            URL_PATTERNS.includes.some(pattern => href.includes(pattern))) {
          return
        }

        // Encode data to prevent issues with special characters
        const idoCode = encodeURIComponent(CurrentUser.getIdoCode())
        const arkId = encodeURIComponent(Env.getArkId())
        const defaultExternalUrlForGar = Env.getDefaultExternalUrlForGar()

        link.setAttribute('href', `${defaultExternalUrlForGar}?idRessource=${arkId}&IDO=${idoCode}&urlDest=${href}`)
      })
    }
  }
}

export default LinksRewriteProcessing
